import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { GRAMPANCHAYAT_CONFIG_URL } from "../../../../api/api_routing_urls";
import useAuth from "../../../../authentication/hooks/useAuth";
import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import Dashboard from "../../../../common/Dashboard";
import MasterConfigHeaderWithoutDeleteWrapper from "../../../../common/master-config/MasterConfigHeaderWithoutDeleteWrapper";
import GenericModal from "../../../../reusable-components/modals/GenericModal";
import showToast from "../../../../utilities/notification/NotificationModal";
import AddGramPahchayatForm from "./AddGramPanchayatForm";
import GramPanchayatList from "./GramPanchayatList";

const GramPanchayatConfig = () => {
  const { auth } = useAuth();

  const [gramPanchayatList, setGramPanchayatList] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const [showAddForm, setShowAddForm] = useState(false);
  const [editGramPanchayatDetails, setEditGramPanchayatDetails] = useState({});
  const isEdit =
    Object.keys(editGramPanchayatDetails).length > 0 ? true : false;
  const controller = new AbortController();
  const getGramPanchayatList = async () => {
    try {
      const response = await axiosPrivate.get(GRAMPANCHAYAT_CONFIG_URL, {
        signal: controller.signal,
      });

      response.status === 200 &&
        setGramPanchayatList(response.data.grampanchayatList);
      response.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      console.error(error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error"
        );
      }
    }
  };

  useEffect(() => {
    let isMounted = true;
    getGramPanchayatList();
    setEditGramPanchayatDetails({});
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);
  return (
    <Dashboard sidebarType={auth.rolename}>
      <ToastContainer />
      <MasterConfigHeaderWithoutDeleteWrapper
        headerTitle={"Gram Panchayat"}
        setShowAddForm={setShowAddForm}
      />
      <GenericModal
        open={showAddForm}
        setOpen={setShowAddForm}
        title={` ${isEdit ? "Update Gram Panchayat" : "Add Gram Panchayat"}`}
        isAdd={true}
      >
        <AddGramPahchayatForm
          getGramPanchayatList={getGramPanchayatList}
          editGramPanchayatDetails={editGramPanchayatDetails}
          setEditGramPanchayatDetails={setEditGramPanchayatDetails}
          setShowAddForm={setShowAddForm}
        />
      </GenericModal>
      <div className="grid grid-cols-1">
        <GramPanchayatList
          gramPanchayatList={gramPanchayatList}
          setEditGramPanchayatDetails={setEditGramPanchayatDetails}
          setShowAddForm={setShowAddForm}
        />
      </div>
    </Dashboard>
  );
};

export default GramPanchayatConfig;
